module.exports = __webpack_public_path__ + "static/pic03-ecc1f17040ad7d8088cc41208113fa45.jpg";